export default "__VITE_ASSET__DCNyrZ____"